import { RootContainer } from '../../../../core/root_container';
import { AddRecommendationItemJsEnv } from '../../models/add_recommendation_item_js_env';
import { AddRecommendationItemAction } from '../../actions/add_recommendation_item_action';
import {
  CreateFolderButton,
  AddRecommendationButton,
  AddRecommendationVariationButton, AddRecommendationVariationItemButton
} from '../button';
import { FolderName } from '../input';
import { FinishMessage } from '../text';
import { CreateFolderWarningCreateFolder } from '../warning';
import { isIe } from '../../../../core/util/browser_util';
import { AddRecommendationItemBody } from './add_recommendation_item_body';

export class AddRecommendationItemContainer extends RootContainer<AddRecommendationItemJsEnv> {
  constructor(model: AddRecommendationItemJsEnv) {
    super();
    const buttonCollection: any = document.getElementsByClassName(
      'add-recommendation-submit-button'
    );
    buttonCollection.forEach((e) => {
      if (e.dataset.isVariationBtn) {
        this.mount(AddRecommendationVariationButton, e.id);
      } else if (e.dataset.isVariationItemBtn) {
        // IE11でバリエーション一覧画面で高さを調整するために2つテーブルが存在するため、is-cloneのテーブルにもマウントする
        // また、高さを保つためにオリジナルのテーブルにもマウントする
        // IEで2つテーブルを作る実装は以下をご参照ください。
        // https://github.com/askul/trylion-phase1-club-template/blob/develop/src/cms/assets/js/ieStickyCol.ts
        this.mount(AddRecommendationVariationItemButton, e.id);
        if(isIe) {
          this.mountByCssSelector(AddRecommendationVariationItemButton, `.is-clone #${e.id}`);
        }
      } else {
        this.mount(AddRecommendationButton, e.id);
      }
    });
    this.mount(AddRecommendationItemBody, 'modal-SLPSRC017-01-content');
    this.mount(CreateFolderButton, 'js-add-recommendation-item-create-folder-button');
    this.mount(FolderName, 'js-add-recommendation-item-input-folder-name');
    this.mount(
      CreateFolderWarningCreateFolder,
      'js-add-recommendation-item-modal-warning-create-folder'
    );
    this.mount(FinishMessage, 'js-add-recommendation-item-finish-message');

    this.reInitModal();
    this.update(model);
    AddRecommendationItemAction.UPDATE_EVENT.on((model: AddRecommendationItemJsEnv) => {
      this.update(model);
    });
  }

  private reInitModal() {
    // this.update(model);にエラー発生する可能性がありますので、
    // setTimeoutでupdateの後に実行させる
    setTimeout(() => {
      const WindowModal = window._modal;
      return new WindowModal('data-reinit-micromodal-trigger');
    }, 1);
  }
}
